import { gql } from '@apollo/client/core';

export const RetrieveBillingAccountContacts = gql`
  query ($data: BillingAccountContactWhereInput) {
    billingAccountContacts(where: $data) {
      id
      email
    }
  }
`;
